<app-header *ngIf="!hideShell" (languageChanged)="onLanguageChanged($event)"></app-header>
<router-outlet></router-outlet>
<app-footer *ngIf="!hideShell"></app-footer>
<app-cookie-consent-banner *ngIf="!hideShell"></app-cookie-consent-banner>
